/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import {pxToEm, replacePXinStringWithEM} from "utils/styles/style_helpers";



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
export default theme =>({
    alert: {
        width: replacePXinStringWithEM(`calc(100% - 20px)`),
        // height: pxToEm(51),
        display: 'flex',
        alignItems: 'flex-start',
        justifyContent: 'space-between',
        margin: replacePXinStringWithEM(`10px 0px 10px 10px`),
        padding: pxToEm(17),

        // animation
        animationDelay: '0s',
        animationDuration: '.15s',
        animationFillMode: 'forwards',

        // ----- alignment ----- //
        '&.align-top-left': {
            boxShadow: theme.boxShadow.small,
            marginBottom: pxToEm(5),
            animationName: 'slideInDown',
        },
        '&.align-top-right': {
            boxShadow: theme.boxShadow.small,
            marginBottom: pxToEm(5),
            animationName: 'slideInDown',
        },
        '&.align-bottom-left': {
            boxShadow: theme.boxShadow.smallTop,
            marginTop: pxToEm(5),
            animationName: 'slideInUp',
        },
        '&.align-bottom-right': {
            boxShadow: theme.boxShadow.smallTop,
            marginTop: pxToEm(5),
            animationName: 'slideInUp',
        },

        // ----- names ----- //
        '& .name-icon-text': {
            display: 'flex',
            alignItems: 'flex-start'
        },
        '& .name-times': {
            margin: pxToEm(18),
            cursor: 'pointer'
        },

        // ----- icon ----- //
        '& .alert-icon': {
            marginRight: pxToEm(8)
        },

        // ----- title ----- //
        '& .title': {
            marginRight:pxToEm(5)
        },
        '& .title-text': {
            display: 'flex',
            flexWrap: 'wrap'
        },


        // ----- size ----- //
        '&.size-full': {
            width: '100%',
            margin: replacePXinStringWithEM('0 0 25px')
        },

        // ----- variants ----- //
        '&.variant-primary': {
            background: theme.color.primary.medium.swatch,
            color: theme.color.primary.medium.contrast
        },
        '&.variant-secondary': {
            background: theme.color.secondary.medium.swatch,
            color: theme.color.secondary.medium.contrast
        },
        '&.variant-attention': {
            background: theme.color.attention.dark.swatch,
            color: theme.color.attention.dark.contrast
        },
        '&.variant-neutral':{
            color: theme.color.supporting.medium.swatch,
            background: theme.color.supporting.light.swatch,
            '& .icon':{
                color: theme.color.neutral.medium.swatch,
            }
        },
        '&.display-false': {
            display: 'none'
        }
    }
})